import useNotifierOriginal from './hooks/useNotifier';
export * from './hooks/useNotifier';

export const useNotifier = useNotifierOriginal;
